import { ENUM__page_generation_layout_images_edit_tab } from '@/pages/page_generation/layouts/assets_images/ENUM__page_generation_layout_images_edit_tab';
import { store } from '@/state/store';
import { assert_false } from '@shared/asserts/utils_asserts';
import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '@shared/dto/generation/graph_invoke/_fields/image/FIELD__image_asset';
import { ENUM__invocation_type } from '@shared/dto/generation/graph_invoke/_invocations/_base/ENUM__invocation_type';

const ENUM_TAB = ENUM__page_generation_layout_images_edit_tab;
const ENUM_IAC = ENUM__image_asset_category;

export function FN_IMAGE__get_available_tabs(field: FIELD__image_asset) {
  assert_false(field.meta.data__is_linked);

  if (field.is_stub()) return [];

  let { generation_current } = store.getState().slice_generation;

  if (generation_current.is_stub()) return [];

  let { graph } = generation_current.tool;

  /*
   *
   */

  let fields_map = graph.fields__get_map();

  if (!fields_map.has(field.meta.field_id)) return [];

  if (field.meta.kind__is_output) return [ENUM_TAB.VIEW];
  if (field.meta.ui__is_readonly) return [ENUM_TAB.VIEW];

  let out = get_tabs_for_category(field.category);

  /*
   * UNDERLAY
   */

  /*
   * MASK
   */
  if (field.category != ENUM__image_asset_category.MASK) {
    let image_mask = graph.field_image__get_mask_for(field);

    if (!image_mask.is_stub()) out.push(ENUM_TAB.MASK);
  }

  /*
   * NODE RELATED
   */

  if (field.meta.node_type == ENUM__invocation_type.IMAGE__VIEWPORT) {
    out.push(ENUM_TAB.CROP);
  }

  /*
   * OUT
   */
  out.unshift(ENUM_TAB.VIEW, ENUM_TAB.SELECT);

  out = out.unique_values();

  return out;
}

function get_tabs_for_category(category: ENUM__image_asset_category) {
  let out_map = new Map<ENUM__image_asset_category, ENUM__page_generation_layout_images_edit_tab[]>([
    [ENUM_IAC.ANY, []],
    [ENUM_IAC.IMAGE, []],
    [ENUM_IAC.MASK, [ENUM_TAB.MASK]],
    [ENUM_IAC.COLOR_MAP, []],
    [ENUM_IAC.LINE__CANNY, [ENUM_TAB.LINE__DRAW]],
    [ENUM_IAC.LINE__SOFT_EDGE, [ENUM_TAB.LINE__DRAW]],
    [ENUM_IAC.DEPTH, []],
  ]);

  let out = out_map.get_or_assert(category);

  return out;
}

function get_tabs_for_category_segment_related(category: ENUM__image_asset_category) {
  let out_map = new Map<ENUM__image_asset_category, ENUM__page_generation_layout_images_edit_tab[]>([
    [ENUM_IAC.IMAGE, [ENUM_TAB.SEGMENTS]],
    [ENUM_IAC.MASK, [ENUM_TAB.SEGMENTS_TO_MASK]],
    [ENUM_IAC.LINE__CANNY, []],
    [ENUM_IAC.LINE__SOFT_EDGE, []],
  ]);

  let out = out_map.get_or_assert(category);

  return out;
}
